export class Counter {
    counter: HTMLElement;

    constructor(counter) {
        this.counter = counter;
        this.init();
    }

    init() {
      this.counter.innerHTML = '0';
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          console.log();
          if (entry.target.attributes.getNamedItem('data-counter').value != 'done' && entry.isIntersecting) {
            this.count(parseInt(entry.target.attributes.getNamedItem('data-counter').value));
          }
        });
      }, {
        root: null,
        rootMargin: "-100px 0% -20%",
        threshold: 1
      });
      observer.observe(this.counter);
    }

    count(number: number) {
      const duration = 2000;
      const startTime = Date.now();

      const step = () => {
        const currentTime = Date.now();
        const progress = Math.min((currentTime - startTime) / duration, 1);

        this.counter.innerHTML = Math.floor(progress * number).toLocaleString();

        // counter shall not exceed lastVal
        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          this.counter.dataset.counter = 'done';
          window.cancelAnimationFrame(window.requestAnimationFrame(step));
        }
      };

      window.requestAnimationFrame(step);
    }
}

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll<HTMLElement>('[data-counter]').forEach((counter) => {
    new Counter(counter);
  });
});
